
import React, { useEffect } from "react";

const heroImage = "/lovable-uploads/b104f49d-a175-41dc-ad6c-8939c00532c7.png";

const ServicesHero = () => {
  // Preload the hero image immediately on component mount
  useEffect(() => {
    const img = new Image();
    img.src = heroImage;
    img.fetchPriority = "high";
    img.decoding = "async";
  }, []);

  return (
    <div className="relative w-full h-[600px] overflow-hidden">
      <div className="absolute inset-0 flex flex-col justify-end pb-16 z-10">
        <div className="w-full flex">
          <div className="w-[90%] md:w-[85%] lg:w-[80%] xl:w-[75%] text-right p-4 md:p-6 bg-orange-400">
            <div className="ml-auto w-[55%] text-left">
              <div className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-[2.8rem] leading-none font-bold text-white">
                Efficient & Innovative
              </div>
              <div className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-[2.8rem] leading-none font-bold text-white mt-2">
                Traffic Control Services
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute w-full h-full">
        <img
          src={heroImage}
          alt="Efficient & Innovative Traffic Control Services"
          className="w-full h-full object-cover"
          loading="eager"
          fetchpriority="high"
          decoding="async"
        />
      </div>
    </div>
  );
};

export default ServicesHero;
